import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { getCurrentUser } from './services/api';
import Layout from './pages/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Group from './pages/Group';
import Invitation from './pages/Invitation';
import MyTasks from './pages/MyTasks';
import AllTasks from './pages/AllTasks';
import TechChat from './pages/TechChat';
import './App.css';
import './styles/Layout.css';
function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    try {
      const response = await getCurrentUser();
      if (response.data.user) {
        setUser(response.data.user);
      }
    } catch (error) {
      console.log('לא מחובר');
    }
    setLoading(false);
  };

  if (loading) {
    return <div className="loading">טוען...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
        <Route path="/invitation/:token" element={<Invitation user={user} setUser={setUser} />} />
        
        {/* Protected Routes - with Layout */}
        <Route path="/dashboard" element={
          user ? (
            <Layout user={user} setUser={setUser}>
              <Dashboard user={user} />
            </Layout>
          ) : <Navigate to="/" />
        } />
        
        <Route path="/group/:groupId" element={
          user ? (
            <Layout user={user} setUser={setUser}>
              <Group user={user} />
            </Layout>
          ) : <Navigate to="/" />
        } />
        
        <Route path="/my-tasks" element={
          user ? (
            <Layout user={user} setUser={setUser}>
              <MyTasks user={user} />
            </Layout>
          ) : <Navigate to="/" />
        } />
        
        <Route path="/all-tasks/:type" element={
          user ? (
            <Layout user={user} setUser={setUser}>
              <AllTasks user={user} />
            </Layout>
          ) : <Navigate to="/" />
        } />
        
        <Route path="/tech-chat" element={
          user ? (
            <Layout user={user} setUser={setUser}>
              <TechChat user={user} />
            </Layout>
          ) : <Navigate to="/" />
        } />
      </Routes>
    </Router>
  );
}

export default App;